import React from 'react'
import { PrimaryButton } from '../../../../../components/Button'
import Checkbox from '../../../../../components/FormComponents/Checkbox'
import Megaphone from '../../../../../components/Images/Megaphone'
import Loader from '../../../../../components/Loader'
import { Popup } from '../../../../../components/Popup'
import { Box, Text } from '../../../../../designSystem'


function DeclarationPopup({
  declarationPopUp,
  handlePopUpClose,
  updateCdCheckbox,
  cdCheckbox,
  handleVersionPublishPopUp,
  popUpLoader
}) {
  return (
    <Popup
      show={declarationPopUp}
      close={handlePopUpClose}
      renderActions={
        <PrimaryButton
          active={
            cdCheckbox.copyright_declaration &&
            cdCheckbox.sexual_content_declaration &&
            cdCheckbox.non_consensual_sex_declaration
          }
          onClick={handleVersionPublishPopUp}
        >
          {popUpLoader ? (
            <Loader size="md" inline="inline" invertColor="#FFFFFF" />
          ) : (
            'Publish'
          )}
        </PrimaryButton>
      }
    >
      <Box
        variant="flex"
        alignItems="center"
        mb={8}
        justifyContent="flex-start"
      >
        <Megaphone />
        <Text variant="titleSecondary" ml={8}>
          Content Declaration
        </Text>
      </Box>
      <Checkbox
        onChange={(val) => {
          if (!popUpLoader)
            updateCdCheckbox({
              copyright_declaration: val,
              sexual_content_declaration: cdCheckbox.sexual_content_declaration,
              non_consensual_sex_declaration:
                cdCheckbox.non_consensual_sex_declaration,
            })
        }}
        name="copyright_declaration"
        value={cdCheckbox.copyright_declaration}
        msgTxt="You are the sole owner of the copyright of the work and is this an original work of fiction."
      />
      <Checkbox
        onChange={(val) => {
          if (!popUpLoader)
            updateCdCheckbox({
              copyright_declaration: cdCheckbox.copyright_declaration,
              sexual_content_declaration: val,
              non_consensual_sex_declaration:
                cdCheckbox.non_consensual_sex_declaration,
            })
        }}
        name="sexual_content_declaration"
        value={cdCheckbox.sexual_content_declaration}
        msgTxt="The book does NOT contain any sexual content featuring characters under the age of 18."
      />
      <Checkbox
        onChange={(val) => {
          if (!popUpLoader)
            updateCdCheckbox({
              copyright_declaration: cdCheckbox.copyright_declaration,
              sexual_content_declaration: cdCheckbox.sexual_content_declaration,
              non_consensual_sex_declaration: val,
            })
        }}
        name="non_consensual_sex_declaration"
        value={cdCheckbox.non_consensual_sex_declaration}
        msgTxt="The book does NOT contain non-consensual sex."
      />
    </Popup>
  )
}

export default DeclarationPopup